import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';


export const CollaborativeAgreementSignedListItem: React.VFC<{
  document: CollaborativeAgreementSigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);

  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      sx={selected ? { borderRight: '3px solid', borderRightColor: 'secondary.main' } : undefined}
    >
      <ListItemText
        primary={template.name}
        secondary={CalendarDateService.date(document.signedAt, DateFormats.ISO_DATE).format(DateFormats['MMM D, YYYY'])}
      />
    </ListItemButton>
  );
};
